export default{
  screen:{
    width:1920,
    height:1080,
    scale:20
  }//大屏设计宽高
}



// WEBPACK FOOTER //
// ./src/config/base.js